import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import PlaceholderLoader from 'shared/modules/ekyc/components/atoms/PlaceholderLoader';

const AppLoader = () => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  if (isBigScreen) {
    return (
      <View style={styles.root}>
        <PlaceholderLoader style={styles.loader} />
      </View>
    );
  } else {
    return (
      <View style={styles.rootMobile}>
        <PlaceholderLoader
          style={[
            styles.loaderMobile,
            {
              width: 101,
              height: 32,
            },
          ]}
        />
        <PlaceholderLoader
          style={[
            styles.loaderMobile,
            {
              width: '100%',
              height: 32,
            },
          ]}
        />
        <PlaceholderLoader
          style={[
            styles.loaderMobile,
            {
              width: '100%',
              height: 216,
            },
          ]}
        />
        <PlaceholderLoader
          style={[
            styles.loaderMobile,
            {
              width: '100%',
              height: 32,
            },
          ]}
        />
        <PlaceholderLoader
          style={[
            styles.loaderMobile,
            {
              width: '100%',
              height: 216,
            },
          ]}
        />
      </View>
    );
  }
};

const styles = StyleSheet.create({
  root: {
    paddingTop: 88,
    alignItems: 'center',
  },
  rootMobile: {
    position: 'absolute',
    top: 0,
    height: '100svh',
    width: '100%',
    alignItems: 'flex-start',
    backgroundColor: '#F0F0F0',
    paddingLeft: 16,
    paddingRight: 15,
    paddingTop: 44,
  },
  loader: {
    width: 424,
    height: 604,
    borderRadius: 8,
  },
  loaderMobile: {
    borderRadius: 8,
    marginVertical: 12,
  },
});

export default AppLoader;
